import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForYouSection() {
  const forYou = ['Tu bebé tiene entre 0 y 5 meses y sufre de llanto inconsolable.', 'Sientes que la falta de sueño está afectando tu relación de pareja.', 'Buscas una solución física y natural, sin recurrir a fármacos innecesarios.', 'Eres un padre/madre de 35+ que valora su tiempo y soluciones directas al punto.'];
  const notForYou = ['Buscas un libro de 300 páginas sobre psicología infantil.', 'Prefieres esperar meses a que el problema "se resuelva solo".', 'No estás dispuesto a aplicar técnicas físicas sencillas con tu bebé.'];
  return <section className="py-24 bg-white" data-id="element-63">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-64">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16" data-id="element-65">
          {/* ESTO ES PARA TI SI */}
          <FadeIn direction="right" data-id="element-66">
            <div className="bg-green-50/50 p-8 md:p-10 rounded-3xl border border-green-100" data-id="element-67">
              <h3 className="text-2xl font-bold text-earth-darker mb-8 flex items-center gap-3" data-id="element-68">
                <CheckCircle2 className="w-8 h-8 text-green-500" data-id="element-69" />
                ESTO ES PARA TI SI:
              </h3>
              <ul className="space-y-6" data-id="element-70">
                {forYou.map((item, idx) => <li key={idx} className="flex gap-4" data-id="element-71">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-72" />
                    <span className="text-earth-darker text-lg leading-relaxed" data-id="element-73">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* ESTO NO ES PARA TI SI */}
          <FadeIn direction="left" delay={0.2} data-id="element-74">
            <div className="bg-red-50/50 p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-75">
              <h3 className="text-2xl font-bold text-earth-darker mb-8 flex items-center gap-3" data-id="element-76">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-77" />
                ESTO NO ES PARA TI SI:
              </h3>
              <ul className="space-y-6" data-id="element-78">
                {notForYou.map((item, idx) => <li key={idx} className="flex gap-4" data-id="element-79">
                    <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-80" />
                    <span className="text-earth-darker text-lg leading-relaxed" data-id="element-81">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}